import React, { useState } from 'react';

const FlightForm = ({ onSave, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    airline: initialData?.airline || '',
    flightNumber: initialData?.flightNumber || '',
    departureAirport: initialData?.departureAirport || '',
    departureDate: initialData?.departureDate || '',
    departureTime: initialData?.departureTime || '',
    arrivalAirport: initialData?.arrivalAirport || '',
    arrivalDate: initialData?.arrivalDate || '',
    arrivalTime: initialData?.arrivalTime || '',
    seats: initialData?.seats || '',
    confirmationNumber: initialData?.confirmationNumber || '',
    liveTracking: initialData?.liveTracking !== false,
    description: initialData?.description || '',
    price: initialData?.price || '',
    photos: initialData?.photos || [],
    documents: initialData?.documents || []
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      price: parseFloat(formData.price) || 0
    });
  };

  return (
    <form onSubmit={handleSubmit} className="component-form flight-form">
      <div className="form-section">
        <h4>Flight Information</h4>
        
        <div className="form-group">
          <label>Title/Description*</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({...formData, title: e.target.value})}
            placeholder="e.g., Outbound Flight to Paris"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Airline*</label>
            <input
              type="text"
              value={formData.airline}
              onChange={(e) => setFormData({...formData, airline: e.target.value})}
              placeholder="e.g., Delta Airlines"
              required
            />
          </div>
          <div className="form-group">
            <label>Flight Number*</label>
            <input
              type="text"
              value={formData.flightNumber}
              onChange={(e) => setFormData({...formData, flightNumber: e.target.value})}
              placeholder="e.g., DL1234"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>
            <input
              type="checkbox"
              checked={formData.liveTracking}
              onChange={(e) => setFormData({...formData, liveTracking: e.target.checked})}
            />
            Enable Live Flight Tracking
          </label>
        </div>
      </div>

      <div className="form-section">
        <h4>Departure</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>Departure Airport*</label>
            <input
              type="text"
              value={formData.departureAirport}
              onChange={(e) => setFormData({...formData, departureAirport: e.target.value})}
              placeholder="e.g., LAX"
              required
            />
          </div>
          <div className="form-group">
            <label>Departure Date*</label>
            <input
              type="date"
              value={formData.departureDate}
              onChange={(e) => setFormData({...formData, departureDate: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Departure Time</label>
            <input
              type="time"
              value={formData.departureTime}
              onChange={(e) => setFormData({...formData, departureTime: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Arrival</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>Arrival Airport*</label>
            <input
              type="text"
              value={formData.arrivalAirport}
              onChange={(e) => setFormData({...formData, arrivalAirport: e.target.value})}
              placeholder="e.g., CDG"
              required
            />
          </div>
          <div className="form-group">
            <label>Arrival Date*</label>
            <input
              type="date"
              value={formData.arrivalDate}
              onChange={(e) => setFormData({...formData, arrivalDate: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Arrival Time</label>
            <input
              type="time"
              value={formData.arrivalTime}
              onChange={(e) => setFormData({...formData, arrivalTime: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Booking Details</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>Seats</label>
            <input
              type="text"
              value={formData.seats}
              onChange={(e) => setFormData({...formData, seats: e.target.value})}
              placeholder="e.g., 12A, 12B"
            />
          </div>
          <div className="form-group">
            <label>Confirmation Number (PNR)</label>
            <input
              type="text"
              value={formData.confirmationNumber}
              onChange={(e) => setFormData({...formData, confirmationNumber: e.target.value})}
              placeholder="e.g., ABC123"
            />
          </div>
          <div className="form-group">
            <label>Price*</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => setFormData({...formData, price: e.target.value})}
              placeholder="0.00"
              min="0"
              step="0.01"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Additional Description</label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({...formData, description: e.target.value})}
            placeholder="Add any additional details about this flight..."
            rows="3"
          />
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          {initialData ? 'Update' : 'Add'} Flight
        </button>
      </div>
    </form>
  );
};

export default FlightForm;
